import { Options } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subscription } from 'rxjs';
import { CandidateService } from 'src/app/services/CandidateService';
import { GigsumoConstants, USER_TYPE } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { CommonValues } from 'src/app/services/commonValues';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService, updateStatusCheckBox } from 'src/app/services/job.service';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { filterConfig } from 'src/app/types/filterConfig';
import { CommunicationService } from 'src/shared/services/CommunicationService';
import { MatMenuModule } from '@angular/material/menu';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-candidate-filter-template',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule,
MatMenuModule, CommonSkeletonComponent,
    NG_ICON_DIRECTIVES,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './candidate-filter-template.component.html',
  styleUrls: ['./candidate-filter-template.component.scss']
})
export class CandidateFilterTemplateComponent implements OnInit, OnDestroy, OnChanges {
  @Input() viewType: string;
  @Input() businessId : string = "";
  @Input() candidateFilterData: filterConfig;
  @Input() filterChanges: any;
  @Input('loading') isLoading : boolean = false;

  candidateSourceFlag: boolean = false
  jobClassificationFlag: boolean = false
  availableForFlag: boolean = false
  candidateFlag: boolean = false
  workAuthFlag: boolean = false
  locationFlag: boolean = false
  workTypeFlag: boolean = false
  experienceFlag: boolean = false
  suggestionStick: boolean = false
  previousSearchAfterKey = null;
  benchSalesCandidates: any;
  myCandidates: boolean = true
  featured: boolean = false;
  filterOn: boolean = false
  count: number = 0
  filteredCandidates: boolean = false
  response: any = [];
  dataPass: any = [];
  stopscrollFlag: boolean = false
  candidateLength: number
  userType = localStorage.getItem('userType')
  jobfilter = false;
  totalFilters: number = 0;
  filterdata: any = {};
  candidateFoundStatus: any = "Fetching Candidates..."
  dataPasstoSkillwidgets: any;
  removeSelected: any;
  FeaSugg: boolean = false
  activeStatus: boolean = null;
  removeTagvalues: any;
  stateListCA: any;
  stateListIN: any;
  stateListAU: any;
  candidateFilterForm: UntypedFormGroup;
  countryList: any = [];
  candidateSource: Array<any> = [];
  engagementType: any = [];
  status: any = [];
  filterApplied: boolean = false
  workAuthorization: any = [];
  activeIds = [];
  @ViewChild("lgModal") lgModal;
  highValue2: number;
  refreshCandidates: Subscription
  filterReload: Subscription
  value: number = 0;
  highValue: number = 0;
  options: Options = {
    floor: 0,
    ceil: 50
  };
  previousSearchAfterKey1 = null;
  statusFlag: boolean = false
  myCandidateFlag: boolean = false
  countryFlag: boolean = false
  totalExperienceFlag: boolean = false
  benchCandidatesFlag: boolean = false
  remoteWorkFlag: boolean = false
  postedInDaysFlag: boolean = false
  experienceToFlag: boolean = false
  experienceFromFlag: boolean = false
  cityFlag: boolean = false
  zipcodeFlag: boolean = false
  workFromHomeFlag: boolean = false
  stateFlag: boolean = false
  relocationRequiredFlag: boolean = false
  engagementTypeFlag: boolean = false
  workAuthorizationFlag: boolean = false
  featuredCandidatesFlag: boolean = false
  totalCandidatesCount: number = 0;
  datas: any = {};
  postDateApplied: boolean = false
  value1: number = 0;
  highValue1: number = 0;
  options1: Options = {
    floor: 0,
    ceil: 99
  };
  owner: boolean = false
  showsuggJobsData: any = [];
  formDataPost: any = {};
  keyarrayCandidatesouces = CandidateService.FILTER_ELEMENT;
  keysarrWorks = ["All", "Onsite", "Remote", "Hybrid"];
  searchContent: any;
  userIdStorage = localStorage.getItem('userId')
  candiSourceSearchRoute = null
  searchUserType: any
  candiSourceSelectNetRoute: any
  ScreenLoadBool: boolean = false
  subscription: Subscription;
  isAccordionOpen: boolean;
  messageData: any;
  messagemodelflag: Boolean = false
  //job classification
  availableForCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Corp To Corp', selected: false, disable: false },
    { label: 'W2 - Contract', selected: false, disable: false },
    { label: 'W2 - Full Time', selected: false, disable: false },
    { label: 'Part Time', selected: false, disable: false },
    { label: 'Freelance', selected: false, disable: false },
    { label: 'Internship', selected: false, disable: false },
    { label: 'Contract to Hire', selected: false, disable: false },
    { label: 'Other', selected: false, disable: false },
    // { label: 'Direct Hire', selected: false, disable: false },
  ];
  availablecheckbox = [
    { label: 'All', selected: false, disable: false },
    { label: 'Immediate', selected: false, disable: false },
    { label: '1 Week', selected: false, disable: false },
    { label: '2 Weeks', selected: false, disable: false },
    { label: 'Other', selected: false, disable: false }

  ];
  candidate_status = [];
  statusCheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [
    { label: 'All', selected: false, disable: false },
    { label: 'Available', selected: false, disable: false },
    { label: 'Draft', selected: false, disable: false },
    { label: 'Unavailable', selected: false, disable: false },
  ];
  workModeCheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [
    { label: 'All', selected: false, disable: false },
    { label: 'Onsite', selected: false, disable: false },
    { label: 'Remote', selected: false, disable: false },
    { label: 'Hybrid', selected: false, disable: false },
  ];
  WACheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [];
  ischeckedJobSource: boolean = false
  ischeckedJobSourceAll: boolean = false
  ischeckedClientType: boolean = false
  ischeckedClientTypeAll: boolean = false
  ischeckedStatus: boolean = false
  ischeckedStatusAll: boolean = false
  ischeckedJobClassification: boolean = false
  ischeckedJobClassificationAll: boolean = false
  ischeckedWorkType: boolean = false
  ischeckedWorkTypeAll: boolean = false
  totalmsgcount: Subscription;
  colurclass = ['fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-saffron-color',
    'fa fa-circle font-9 icon-prime-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-yellow-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-green-color',
    'fa fa-circle font-9 icon-orange-color',
    'fa fa-circle font-9 icon-red-color',
    'fa fa-circle font-9 icon-blue-color',
    'fa fa-circle font-9 icon-saffron-color'];
  feaJ: boolean;
  profile: any
  networkflag: boolean = false;
  receiveFilterData: Subscription;
  resetFilter: Subscription;
  countSouce: number = 0;
  sendProfileData: any = {}
  validTotalPoints: boolean
  totalCount
  listingCount = 0;
  freelanceCount = 0;
  creditsConsume: any = 0;
  availablePoints;
  queryParamsValues: any
  valid: boolean = true;
  usStatesList = []
  showWorkAuthorization: boolean = false
  img: any;
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }
  obj1: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }
  yearApplied: boolean = false
  isMyCandidateShowedOnLoad: boolean = false;
  filterSubscriber: Subscription;
  isFilterOpen: boolean = false;
  isEnabled: boolean=false;
  personalNetworks: Array<any> = [];
  memberNetworks: Array<any> = [];
  businessNetworkData: Array<any> = [];
  publishedPayload = {
    memberNetworkChosen : false,
    all : false,
    personalNetworks : [],
    users : [],
    type:"CANDIDATE",
    userId : null ,
    searchContent: null,
    searchAfterKey : null,
    limit : 10
  }
  customerPayload= {
    businessId: null,
    userId : null,
    memberNetworkChosen : false,
    businessNetworkChosen : false,
    businessNetworks: [],
    businessList: [],
    searchContent:null,
    searchAfterKey : null,
    limit: 10
  };
  filterFormData: any;
  publishedByStopScroll: boolean = false;
  publishedByPrevSearchAfterKey: any;
  customersPrevSearchAfterKey: any;
  customersStopScroll: boolean = false;
  istempBusinessNetwork: boolean = false;
  customerCount: number = 0;
  publishedByCount: number = 0;
  busienssNetworkCount: number = 0;
  tempBusinessNetworks: any[];
  selectedNetworkId: any;
  isDefaultNetwork: boolean = false;
  membershipType = localStorage.getItem('MemberShipType');

  constructor(private apiService: ApiService, private communicationService: CommunicationService, private searchData: SearchData,
    private activatedRoute: ActivatedRoute, private commonvalues: CommonValues, private formBuilder: UntypedFormBuilder, private util: UtilService, private candidateService: CandidateService, private jobService: JobService, private gigsumoService: GigsumoService, private router: Router) {

    this.createCandidateFilterForm();
    this.getCandidateSource();
    this.filterSubscriber = this.jobService.getSliderToggle().subscribe(value => {
      if (value.panel == 'candidate-listing' && value.value == true) {
        this.isFilterOpen = true;
        this.openFilterSlider();
      } else {
        this.isFilterOpen = false;
        this.closeFilterSlider();
      }
    });

    // this.commonvalues.currentData.subscribe(data => {
    //   this.isEnabled = data;
    // });

    this.activatedRoute.queryParams.subscribe((res) => {
      if(res.isDefaultNetwork === 'true'){
        this.isDefaultNetwork = true;
        if (res.networkName === 'BENCH_SALES_NETWORK') {
          this.selectedNetworkId = "benchNetworkCandidates";
        } else if (res.networkName === 'MANAGEMENT_TALENT_ACQUISITION_NETWORK') {
          this.selectedNetworkId = "mtaNetworkCandidates";
        } else if (res.networkName === 'FREELANCE_RECRUITER_NETWORK') {
          this.selectedNetworkId = "freeLancerNetworkCandidates";
        } else if (res.networkName === 'JOB_SEEKER_NETWORK') {
          this.selectedNetworkId = "jobSeekerNetworkCandidates";
        }
    }
    else{
      this.selectedNetworkId = res.networkId;
    }
   });

   this.activatedRoute.data.subscribe(x =>{
    if(x && x[0] != null){
        console.log("candidate-filter-template ", x);
        this.customerPayload.businessId = x[0].businessId;
        this.businessId = x[0].businessId;
      }
   });

  }

  sourceCount: number = 0 ;
  postedDayRangeCount: number = 0;
  engagementTypeCount: number = 0;
  availabilityCount: number = 0;
  statusCount: number = 0;
  workTypeCount: number = 0;
  memberShipType = localStorage.getItem('MemberShipType');

  executeMethod(data: string): void {
    this.sourceCount = 0;
    this.postedDayRangeCount = 0;
    this.engagementTypeCount = 0;
    this.statusCount = 0;
    this.availabilityCount = 0;
  }

  // recieve filter data from new-candidate component
  ngOnChanges(changes: SimpleChanges): void {

    this.publishedPayload.userId = localStorage.getItem('userId');
    this.customerPayload.userId = localStorage.getItem('userId');
    this.updateCandidateFilterData();

    if (changes.filterChanges !== undefined && changes.filterChanges.currentValue != undefined) {
      let data: any = changes.filterChanges.currentValue;
      // fetching the total counts of the source for numbering the filter elements
      // fetching filter number starts here


      if(data.formData.source && data.formData.source.length > 0){
        this.sourceCount = this.computeSourceCount(data.formData.source[0]);
      }

      // jobclassification / engagement type count starts here
      const keyValuePairs2: Record<string, boolean> = {};
      data.engageMentCheckedItems.forEach(item => {
        if(item.label != 'All'){
          keyValuePairs2[item.label] = item.selected;
        }
      });

      const keyCounts2 = Object.values(keyValuePairs2).reduce((count, item) => {
        return count + (item ? 1 : 0);
      }, 0);

      this.engagementTypeCount = keyCounts2;

      // jobclassification / engagement type count ends here

      // availability count starts here
      const keyValuePairs3: Record<string, boolean> = {};
      data.availiabilityCheckedItems.forEach(item => {
        if(item.label != 'All'){
          keyValuePairs3[item.label] = item.selected;
        }
      });

      const keyCounts3 = Object.values(keyValuePairs3).reduce((count, item) => {
        return count + (item ? 1 : 0);
      }, 0);

      this.availabilityCount = keyCounts3;

      // availability count ends here

      // status counts starts here
      const keyValuePairs4: Record<string, boolean> = {};
      data.statusCheckedItems.forEach(item => {
        if(item.label != 'All' && !item.disable){
          keyValuePairs4[item.label] = item.selected;
        }
      });

      const keyCounts4 = Object.values(keyValuePairs4).reduce((count, item) => {
        return count + (item ? 1 : 0);
      }, 0);

      this.statusCount = keyCounts4;


      if(data.workMode && data.workMode.length > 0){
        this.workTypeCount = data.workMode.filter(x => x.label != 'All').reduce((acc, curr) =>{
          return acc + (curr.selected ? 1 : 0);
        }, 0);
      }





      // fetching filter number ends here

      // cadidate source reset filter
      if(data.formData.resetFilter === true){
        this.resetFilterDefault();
      }

      this.filterFormData  = data.formData;
      this.candidateFilterForm.patchValue(this.filterFormData);
      this.candidateSource = data.checkedItems;
      this.availablecheckbox = data.availiabilityCheckedItems;
      this.statusCheckboxes = data.statusCheckedItems;
      this.workModeCheckboxes = data.workMode;
      this.availableForCheckboxes = data.engageMentCheckedItems;
      this.value1 = data.formData.postedFrom != null ? data.formData.postedFrom : 0;
      this.highValue1 = data.formData.postedTo != null ? data.formData.postedTo : 0;

      const isMyCandidatesChecked : boolean  = data.formData.source[0].myCandidates;
      this.statusCheckboxes = updateStatusCheckBox(this.statusCheckboxes , this.owner ? isMyCandidatesChecked : false , false);
      // since we removed the publishedBy , customer and business Network the below code is not needed
      // for future use may be commenting this - prasanna

      let customerSelected = data.customerSelectedData === undefined ? [] : data.customerSelectedData;
      let publishedSelected = data.publishedSelectedData === undefined ? [] : data.publishedSelectedData;

      // if(data.formData.source && data.formData.source.length > 0){

      //   // busniess network interaction
      //   if(data.formData.source[0].businessNetwork != this.istempBusinessNetwork ||
      //     JSON.stringify(data.businessNetworks) != JSON.stringify(this.customerPayload.businessNetworks) ||
      //     JSON.stringify(this.customerPrevSelectedValue) != JSON.stringify(data.customerSelectedData)){
      //     this.setToDefaulFilter("CUSTOMER");
      //     this.istempBusinessNetwork = data.formData.source[0].businessNetwork;
      //     this.customerPayload.businessNetworks = data.businessNetworks === undefined ? [] : data.businessNetworks;
      //     this.customerPayload.businessList = customerSelected.map(x=>x.businessId);
      //     this.getBusinessCustomers();
      //   }

      //   // member and personal network interaction
      //   if(data.formData.source[0].memberNetworksCandidates != this.publishedPayload.memberNetworkChosen ||
      //     JSON.stringify(data.personalNetworks) != JSON.stringify(this.publishedPayload.personalNetworks) ||
      //     JSON.stringify(this.publishedByPrevSelectedValue) != JSON.stringify(data.publishedSelectedData)){
      //     this.setToDefaulFilter();
      //     this.publishedPayload.memberNetworkChosen = data.formData.source[0].memberNetworksCandidates;
      //     this.publishedPayload.personalNetworks = data.personalNetworks === undefined ? [] : data.personalNetworks;
      //     this.publishedPayload.users = publishedSelected.map(x=>x.userId);
      //     this.getPublishedBy();
      //   }

      // }


      // this.businessNetworkPrevSelectedValue =  data.businessNetworkSelectedData === undefined ? [] : data.businessNetworkSelectedData;
      this.customerPrevSelectedValue = customerSelected;
      this.publishedByPrevSelectedValue =  publishedSelected;
      this.selectedPublishedBy = data.publishedByUsers === undefined ? [] : data.publishedByUsers;
      this.selectedCustomers = data.businessCustomers === undefined ? [] : data.businessCustomers;

      // this.customerCount = this.customerPrevSelectedValue != undefined ? this.customerPrevSelectedValue.length : 0;
      // this.publishedByCount = this.publishedByPrevSelectedValue != undefined ? this.publishedByPrevSelectedValue.length : 0;

      // this.selectedBusinessNetworks = data.businessNetworks === undefined ? [] : data.businessNetworks;

      // if(this.businessNetworkPrevSelectedValue.length > 0){
      //   setTimeout(() => {
      //     this.businessNetworkData = this.businessNetworkPrevSelectedValue;
      //     this.busienssNetworkCount = this.businessNetworkPrevSelectedValue != undefined ? this.businessNetworkPrevSelectedValue.filter(x => x.enabled).length : 0;
      //    }, 1000);
      // }


    }


  }

  POSTED_ANY = GigsumoConstants.POSTED_ANY;
  POSTED_TODAY = GigsumoConstants.POSTED_TODAY;
  POSTED_LAST_7_DAYS = GigsumoConstants.POSTED_LAST_7_DAYS;
  POSTED_LAST_14_DAYS = GigsumoConstants.POSTED_LAST_14_DAYS;
  POSTED_LAST_30_DAYS = GigsumoConstants.POSTED_LAST_30_DAYS;

  EXPERIENCE_ANY = GigsumoConstants.EXPERIENCE_ANY;
  EXPERIENCE_JUNIOR = GigsumoConstants.EXPERIENCE_JUNIOR;
  EXPERIENCE_MID_LEVEL = GigsumoConstants.EXPERIENCE_MID_LEVEL;
  EXPERIENCE_SENIOR = GigsumoConstants.EXPERIENCE_SENIOR;
  EXPERIENCE_ARCHITECT = GigsumoConstants.EXPERIENCE_ARCHITECT;

  onPostedDaysChange(content: string) {

    if (content === GigsumoConstants.POSTED_TODAY) {
      this.candidateFilterForm.patchValue({ postedFrom: 1, postedTo: 1 });
    } else if (content === GigsumoConstants.POSTED_LAST_7_DAYS) {
      this.candidateFilterForm.patchValue({ postedFrom: 1, postedTo: 7 });
    } else if (content === GigsumoConstants.POSTED_LAST_14_DAYS) {
      this.candidateFilterForm.patchValue({ postedFrom: 1, postedTo: 14 });
    } else if (content === GigsumoConstants.POSTED_LAST_30_DAYS) {
      this.candidateFilterForm.patchValue({ postedFrom: 1, postedTo: 30 });
    } else {
      this.candidateFilterForm.patchValue({ postedFrom: null, postedTo: null });
    }
     this.updateFunction();
  }

  onExperienceValueChange(content : any) {
    if (content === GigsumoConstants.EXPERIENCE_JUNIOR) {
      this.candidateFilterForm.patchValue({ experienceFrom: 1, experienceTo: 3 });
    } else if (content === GigsumoConstants.EXPERIENCE_MID_LEVEL) {
      this.candidateFilterForm.patchValue({ experienceFrom: 4, experienceTo: 6 });
    } else if (content === GigsumoConstants.EXPERIENCE_SENIOR) {
      this.candidateFilterForm.patchValue({ experienceFrom: 6, experienceTo: 10 });
    } else if (content === GigsumoConstants.EXPERIENCE_ARCHITECT) {
      this.candidateFilterForm.patchValue({ experienceFrom: 10, experienceTo: 20 });
    } else {
      this.candidateFilterForm.patchValue({ experienceFrom: null, experienceTo: null });
    }
    this.updateFunction();
  }



  ngOnInit(): void {
    this.previousSearchAfterKey1 = null;
    this.datas.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.stopscrollFlag = false;
    this.communicationService.setCallback(this)
    this.getSubmissionFilter();
  }

  getSubmissionFilter() {
    this.apiService.create('listvalue/findbyList' , {domain : "JOB_APPLICATION_SUPPLIER_ACTIONS,JOB_APPLICATION_BLOCKING_ACTIONS"}).subscribe(res=>{
        const sorted : Array<any> =  res.data.JOB_APPLICATION_SUPPLIER_ACTIONS && res.data.JOB_APPLICATION_SUPPLIER_ACTIONS.listItems;
        if(sorted){
          this.candidate_status = sorted.map(x => {
            const d = {itemId : x.itemId , label : x.value , selected : false , disable : false }
            return d;
          });
        }
     });
  }

  getCandidateSource() {

    this.gigsumoService.getFilterELement("CANDIDATE" , this.userIdStorage).subscribe(response=>{
      if(response.code === GigsumoConstants.SUCESSCODE){
        this.businessNetworkData =  response.data.businessNetworks;
        this.tempBusinessNetworks = this.businessNetworkData;
        this.personalNetworks = response.data.personalNetworks.map(r=>{
          let data = GigsumoService.FILTER_ITEMS("CANDIDATE").find(x => x.value === r.networkName);
          if(data){
            r.key = data.key;
          }
          else{
            r.key = r.networkId;
          }
          return r;
        });
        this.jobsoucefilterFrom(this.personalNetworks);
      }

    });

  }


  get allBusinessNetwork() {
    return this.businessNetworkData ? this.businessNetworkData.map(x => x.b2bNetworkId) : [];
  }

  get allPersonalNetworks(){
    return this.personalNetworks ? this.personalNetworks.map(x => x.networkId) : [];
  }

  setToDefaulFilter(d = "Published"){
    if(d === "Published"){

      this.publishedPayload.searchAfterKey = null;
      this.publishedByStopScroll = false;
      this.publishedByPrevSearchAfterKey = null;
      this.publishedByList.next([]);
    }
    else{
      this.customerPayload.searchAfterKey = null;
      this.customersStopScroll = false;
      this.customersPrevSearchAfterKey = null;
      this.customersList.next([]);
    }
  }

  publishedByList = new BehaviorSubject<any[]>([]);
  async getPublishedBy() {

    try {
      this.isLoading = true;
      let data = await firstValueFrom(this.apiService.create("business/findNetworkConnections", this.publishedPayload))
      this.gigsumoService.updatePublishedBy(this, data);
      this.isLoading = false;
    } catch (error) {
        this.isLoading = false;
    }
  }

  customersList = new BehaviorSubject<any[]>([]);
  async getBusinessCustomers(from : string = "BUSINESS-NETWORK") {
    if((this.membershipType == "Growth" || this.membershipType == "Starter"||this.membershipType == "ScaleX") || from === 'MEMBER_NETWORK' ){
      try {
          this.isLoading = true;
          this.customerPayload.businessId = this.businessId;
          let data = await firstValueFrom(this.apiService.create("business/findBusinessCustomers", this.customerPayload));
          this.gigsumoService.updateBusinessCustomers(this , data);
          this.isLoading = false;
      } catch (error) {
          this.isLoading = false;
      }
    }

  }

  resetFilterDefault(){
    this.jobsouceCheckedAll(false);
    this.publishedPayload.personalNetworks = [];
    this.customerPayload.businessNetworks = [];
    this.publishedPayload.searchContent = "";
    this.customerPayload.searchContent = "";
    this.selectedBusinessNetworks = [];
    this.selectedPublishedBy = [];
    this.selectedCustomers = [];
    this.businessNetworkData =  this.tempBusinessNetworks;
    this.customerPrevSelectedValue = [];
    this.publishedByPrevSelectedValue = [];
    this.businessNetworkPrevSelectedValue = [];
    this.setToDefaulFilter();
    this.setToDefaulFilter("CUSTOMER");
    this.getPublishedBy();
    this.getBusinessCustomers();
}


  showChevron: boolean = false;
  showChevron1: boolean = false;
  onMouseEnter() {
    this.showChevron = true;
  }

  onMouseLeave() {
    this.showChevron = false;
  }

  onMouseEnter1() {
    this.showChevron1 = true;
  }

  onMouseLeave1() {
    this.showChevron1 = false;
  }

  scrollLeft() {
    const scrollContainer = document.getElementById('scrollContainer');
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: -350, behavior: 'smooth' });
    }
  }

  scrollRight() {
    const scrollContainer = document.getElementById('scrollContainer');
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: 350, behavior: 'smooth' });
    }
  }


  getSelected(content: string): string {

    if (content === "CANDIDATE_SOURCE") {
      const data = this.candidateFilterForm.get('source') as UntypedFormArray;
      let datas = [];
      Object.keys((data.at(0) as UntypedFormGroup).controls).forEach((ele: any) => {
        if (data.at(0).get(ele).value) {
          datas.push(ele);
        }
      });


      return (datas && datas.length > 0) ? this.pickSmall(datas[0]) : "Candidate Source";
    }
    else if (content === "AVAILABILITY") {
      const data = this.availablecheckbox.filter(ele => ele.selected === true)
      return (data && data.length > 0) ? data[0].label : "Availability";
    }
    else if (content === "STATUS") {
      const data = this.statusCheckboxes.filter(ele => ele.selected === true)
      return (data && data.length > 0) ? data[0].label : "Status";
    }
    else if (content === "ENGAGEMENT_TYPE") {
      const data = this.availableForCheckboxes.filter(ele => ele.selected === true)
      return (data && data.length > 0) ? data[0].label : "Engagement Type";
    } else if (content == "POSTED_DAY") {
      return this.candidateFilterForm.get('postedDayRange').value;
    }

    return null;
  }


  pickSmall(val: string): string {
    let candidateSourceItems: Array<string> = ["Platform Candidates", "All", "My Candidates", "My Profile", "Bench Sales Network",
      "Freelancer Network", "MTA Network", "Job Seeker Network", "Pro Candidates", "Featured Candidates", "Marketplace Candidates"];

    return candidateSourceItems.find(x => {
      if (val === "marketPlaceCandidates") {
        val = "Platform Candidates".toLowerCase().replace(/\s/g, '');
      }
      else if (x === "Freelancer Network") {
        x = "Freelancer Network Candidates".toLowerCase().replace(/\s/g, '');
      }
      else if (x === "MTA Network") {
        x = "MTA Network Candidates".toLowerCase().replace(/\s/g, '');
      }
      else if (val === "featured") {
        val = "Featured Candidates".toLowerCase().replace(/\s/g, '');
      }
      else if (x === "suggestedCandidates") {
        x = "Marketplace Candidates".toLowerCase().replace(/\s/g, '');
      }
      else if (val === "benchNetworkCandidates") {
        val = "Bench Sales Network".toLowerCase().replace(/\s/g, '');
      }
      else if (val === "jobSeekerNetworkCandidates") {
        val = "Job Seeker Network".toLowerCase().replace(/\s/g, '');
      }


      return x.toLowerCase().replace(/\s/g, '') === (val && val.toLowerCase())
    });
  }

  updateCandidateFilterData() {
    const userType = localStorage.getItem('userType') as USER_TYPE;

    if (this.isMTAorFREEandBENCHorJOB(userType)) {
      this.owner = true;
    }
    else if (this.isRecruiter(userType)) {
      this.owner = false;
    }

  }

  setDefaultFilter(value: string) {
    this.candidateSource.push(value);
    this.getSource().at(0).get(value).patchValue(true);
  }

  getSource(): UntypedFormArray {
    return this.candidateFilterForm.get('source') as UntypedFormArray;
  }

  isBenchorJob(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.BENCH_RECRUITER
      || userType === GigsumoConstants.JOB_SEEKER);
  }

  isMTAorFREEandBENCHorJOB(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || userType === GigsumoConstants.JOB_SEEKER
      || userType === GigsumoConstants.FREELANCE_RECRUITER || userType === GigsumoConstants.BENCH_RECRUITER);
  }

  isRecruiter(userType): boolean {
    return userType === GigsumoConstants.RECRUITER;
  }

  isMTAorFREE(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || userType === GigsumoConstants.FREELANCE_RECRUITER);
  }

  ngOnDestroy(): void {
    if (this.filterSubscriber) {
      this.filterSubscriber.unsubscribe();
    }
  }

  onLoad() {
    this.ScreenLoadBool = true;
    let data: any = JSON.parse(localStorage.getItem('candidateForm'));
    this.generateWorkAutorization(data.country);

    for (let key in data.source) {
      if (data.source[key] === true) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
        this.candidateSource.push(key)

        this.candidateSource.forEach((ele, index) => {
          if (this.FeaSugg && ele === "featured" || this.FeaSugg && ele === "suggestedCandidates") {
            this.candidateSource.splice(index, 1)
          }
          if (!this.owner && ele === "myCandidates") {
            this.candidateSource.splice(index, 1)
          }
        })

      }
    }
    data.availableIn.forEach((res) => {
      this.availablecheckbox.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.candidateSource.push(res)
        }
      });

    });
    data.status.forEach((res) => {
      this.statusCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.candidateSource.push(res)
        }
      });
    });
    data.engagementType.forEach((res) => {
      this.availableForCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.candidateSource.push(res)
        }
      });
    });




    for (let key in data.workType) {
      if (data.workType[key] === true) {
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
        this.candidateSource.push(key)
      }
    }
    this.candidateSource = [...new Set(this.candidateSource)]
    this.candidateSource.forEach((ele, index) => {
      if (ele === "All" || ele === "all") {
        this.candidateSource.splice(index, 1)
      }
    });

    this.value = data.experienceFrom != null ? data.experienceFrom : 0;
    this.highValue = data.experienceTo != null ? data.experienceTo : 0;
    this.value1 = data.postedFrom != null ? data.postedFrom : 0;
    this.highValue1 = data.postedTo != null ? data.postedTo : 0;

    this.candidateFilterForm.get('country').patchValue(data.country)
    this.candidateFilterForm.get('state').patchValue(data.state)
    this.candidateFilterForm.get('city').patchValue(data.city)
    this.candidateFilterForm.get('zipCode').patchValue(data.zipCode)
    setTimeout(() => {
      data.workAuthorization.forEach((res) => {
        this.WACheckboxes.forEach(item => {
          if (item.label === res) {
            this.showWorkAuthorization = true
            item.selected = true;
            this.candidateSource.push(res)
          }
        });
      });
    }, 1000);


    this.datas = data
    this.response = [];
    // this.commonvalues.setcandidateData(this.response);

    this.previousSearchAfterKey1 = null;
    this.datas.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.stopscrollFlag = false;

    localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
    this.apicallfilter();
   }

  getCredits(val) {

    if (val != null && this.creditsConsume == null) {
      this.creditsConsume = val;
    }
    else if (val != null && this.creditsConsume != null) {
      this.creditsConsume = "";
      this.creditsConsume = val;
    }

  }

  invalidDate(valid: boolean) {
    this.valid = valid;
  }

  // settingUpFilters() {
  //   if (!this.jobfilter) {
  //     if (!this.isMyCandidateShowedOnLoad && !this.networkflag && this.candiSourceSearchRoute == null) {
  //       this.totalFilters = 1
  //       this.candidateSource.push('marketPlaceCandidates');
  //       this.candidateSource = [...new Set(this.candidateSource)];
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('marketPlaceCandidates').patchValue(true);
  //       this.applyFilternew()
  //     } else if (this.isMyCandidateShowedOnLoad && this.owner && !this.networkflag && this.candiSourceSearchRoute == null) {
  //       this.totalFilters = 1
  //       this.candidateSource.push('myCandidates');
  //       this.candidateSource = [...new Set(this.candidateSource)];
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('myCandidates').patchValue(true);
  //       this.applyFilternew()
  //     } else if (this.networkflag) {
  //       this.candidateSource.push(this.candiSourceSelectNetRoute)
  //       this.candidateSource = [...new Set(this.candidateSource)]
  //       this.datas.searchAfterKey = null;
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get(this.candiSourceSelectNetRoute).patchValue(true);
  //       this.applyFilternew();
  //     } else if (this.candiSourceSearchRoute != null) {
  //       this.candidateSource = []
  //       this.candidateSource.push(this.candiSourceSearchRoute)
  //       this.candidateSource = [...new Set(this.candidateSource)]
  //       this.datas.searchAfterKey = null;
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('all').patchValue(false);
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('myCandidates').patchValue(false);
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('teamCandidates').patchValue(false);
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('benchNetworkCandidates').patchValue(false);
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('freeLancerNetworkCandidates').patchValue(false);
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('mtaNetworkCandidates').patchValue(false);
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('jobSeekerNetworkCandidates').patchValue(false);
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get(this.candiSourceSearchRoute).patchValue(true);
  //       this.applyFilternew();
  //     } else {
  //       this.totalFilters = 0
  //       this.candidateSource.push('benchNetworkCandidates')
  //       this.candidateSource = [...new Set(this.candidateSource)];
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get('benchNetworkCandidates').patchValue(true);
  //       this.applyFilternew()
  //     }

  //   } else if (this.jobfilter) {
  //     this.totalFilters = 0
  //     this.applyFilternew();

  //     //   disable for filter
  //     for (let key of this.keyarrayCandidatesouces) {
  //       ((this.candidateFilterForm.get('source') as FormArray).at(0) as FormGroup).get(key).disable();
  //     }

  //     for (let key of this.keysarrWorks) {
  //       ((this.candidateFilterForm.get('workType') as FormArray).at(0) as FormGroup).get(key).disable();
  //     }
  //     this.availableForCheckboxes.forEach(item => item.disable = true);
  //     this.statusCheckboxes.forEach(item => item.disable = true);
  //     this.WACheckboxes.forEach(item => item.disable = true);
  //     this.availablecheckbox.forEach(item => item.disable = true);


  //   }
  // }

  receiveDataFromAccordion(data: any) {
    // Handle the data received from the accordion component
  }

  digitKeyOnly(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    if ((keyCode >= 37 && keyCode <= 40) || (keyCode == 8 || keyCode == 9 || keyCode == 13) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    }
    return false;
  }

  // cancelApplication() {
  //   this.router.navigate(['newjobs'])
  // }

  // cancelFilterValues() {

  //   this.statusFlag = false
  //   this.countryFlag = false
  //   this.totalExperienceFlag = false
  //   this.benchCandidatesFlag = false
  //   this.remoteWorkFlag = false
  //   this.postedInDaysFlag = false
  //   this.experienceToFlag = false
  //   this.experienceFromFlag = false
  //   this.cityFlag = false
  //   this.zipcodeFlag = false
  //   this.workFromHomeFlag = false
  //   this.stateFlag = false
  //   this.relocationRequiredFlag = false
  //   this.engagementTypeFlag = false
  //   this.workAuthorizationFlag = false
  //   this.featuredCandidatesFlag = false
  //   // this.suggestedCandidatesFlag = false
  //   this.lgModal.hide()
  //   this.resetFilter()
  //   this.filterOn = false
  //   this.obj.searchAfterKey = null
  //   if (this.owner) {
  //     this.myCandidateFlag = true
  //     this.applyFilter('manual', null)
  //   } else {
  //     this.myCandidateFlag = false
  //     this.getCandidateList("candidates/findCandidates")
  //   }


  //   this.getchildData(null)
  // }

  // get child date to display widgets
  getchildData(data) {
    if (data != null) {
      this.dataPasstoSkillwidgets = JSON.parse(data);
    } else {
      this.dataPasstoSkillwidgets = [];

    }
  }

  //  user remove after uncheck from widgets
  removeUserfromTag(data) {
    this.removeTagvalues = data;
    this.response.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });

    this.dataPasstoSkillwidgets.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });
  }

  onChangeYear(value) {
    if (value.highValue > 0) {
      this.yearApplied = true
    } else if (value.highValue == 0) {
      this.yearApplied = false
    }
    this.candidateFilterForm.value.experienceFrom = value.value
    this.candidateFilterForm.value.experienceTo = value.highValue
    this.response = []

    this.previousSearchAfterKey1 = null;

    this.datas.searchAfterKey = null
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew()
  }

  zipCodeValidaiton(x: number): boolean {
    if (String(x).length > 10) {
      return false;
    }
    return true;
  }
  onChangepostday(value, param?: any) {
    if (value.highValue > 0) {
      this.postDateApplied = true
    } else if (value.highValue == 0) {
      this.postDateApplied = false
    }
    this.candidateFilterForm.get("postedFrom").patchValue(value.value);
    this.candidateFilterForm.get("postedTo").patchValue(value.highValue)
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew(param);
    this.updateFunction();
  }

  applyFilternew(param?: any) {
    return;
     this.stopscrollFlag = false;
    this.datas.searchAfterKey = null;

    if (this.jobfilter) {
      this.candidateFilterForm.value.jobId = this.filterdata.jobId
    }

    var statusCheckboxesUpdate: any = [];
    this.statusCheckboxes.forEach(element => {
      if (element.selected) {
        statusCheckboxesUpdate.push(element.label)
      }
    });

    var clientTypeCheckboxesUpdate: any = [];
    this.WACheckboxes.forEach(element => {
      if (element.selected) {
        clientTypeCheckboxesUpdate.push(element.label)
      }
    });

    var jobClassificationUpdate = [];
    this.availableForCheckboxes.forEach(element => {
      if (element.selected) {
        jobClassificationUpdate.push(element.label)
      }
    });

    var avalables = [];
    this.availablecheckbox.forEach(element => {
      if (element.selected) {
        avalables.push(element.label)
      }
    });
    var submissionFilters = [];
    this.candidate_status.forEach(element => {
      if (element.selected) {
        let value = element.label;
        if (value == "Pre-Onboarding") {
          value = "PREONBOARDED";
        }
        submissionFilters.push(value.toLocaleUpperCase())
      }
    });

    this.candidateFilterForm.value.workAuthorization = clientTypeCheckboxesUpdate; // work auth values
    this.candidateFilterForm.value.availableIn = avalables;
    this.candidateFilterForm.value.engagementType = jobClassificationUpdate;
    this.candidateFilterForm.value.status = statusCheckboxesUpdate;
    this.candidateFilterForm.value.submissionFilters = submissionFilters;



    this.candidateFilterForm.value.userId = localStorage.getItem('userId')
    if (this.previousSearchAfterKey1 != null || this.previousSearchAfterKey1 != undefined) {
      this.candidateFilterForm.value.searchAfterKey = this.previousSearchAfterKey1;
    } else {
      this.candidateFilterForm.value.searchAfterKey = null;
    }

    if (!this.jobfilter) {
      this.datas = {
        source: this.candidateFilterForm.value.source[0],
        workType: this.candidateFilterForm.value.workType[0]
      };
    }

    if (this.jobfilter) {
      this.datas.jobId = this.candidateFilterForm.value.jobId
      this.datas.source = {
        all: false,
        myCandidates: true,
        marketPlaceCandidates: false,
        teamCandidates: false,
        benchNetworkCandidates: false,
        freeLancerNetworkCandidates: false,
        mtaNetworkCandidates: false,
        jobSeekerNetworkCandidates: false,
        featured: false,
        suggestedCandidates: false
      }
      this.datas.workType = {
        all: false,
        remoteWork: false,
        relocationRequired: false,
        workFromHome: false
      }
    } else {
    }

    this.datas.workAuthorization = clientTypeCheckboxesUpdate,
      this.datas.engagementType = jobClassificationUpdate,
      this.datas.availableIn = avalables,
      this.datas.status = statusCheckboxesUpdate,
      this.datas.searchAfterKey = this.candidateFilterForm.value.searchAfterKey,
      this.datas.city = this.candidateFilterForm.value.city,
      this.datas.state = this.candidateFilterForm.value.state,
      this.datas.country = this.candidateFilterForm.value.country,
      this.datas.zipCode = this.candidateFilterForm.value.zipCode,
      this.datas.submissionFilters = this.candidateFilterForm.value.submissionFilters,
      // this.datas.totalExperience = this.candidateFilterForm.value.totalExperience
      this.datas.experienceFrom = this.candidateFilterForm.value.experienceFrom;
    this.datas.experienceTo = this.candidateFilterForm.value.experienceTo;
    this.datas.postedFrom = this.candidateFilterForm.value.postedFrom
    this.datas.postedTo = this.candidateFilterForm.value.postedTo
    this.datas.limit = this.candidateFilterForm.value.limit,
      this.datas.userId = this.candidateFilterForm.value.userId
    this.datas.searchContent = this.searchContent;
    delete this.datas.searchContent;

    if (this.searchContent != "" && this.searchContent != undefined) {
      this.datas.searchContent = this.searchContent;
      this.datas.searchAfterKey = null;
    }


    if (this.candidateSource.length > 0 && this.searchContent == ""
      || this.candidateSource.length > 0 && this.searchContent == undefined) {
      localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
      localStorage.setItem('candidateForm', JSON.stringify(this.datas));
    }

    if (this.candidateSource.length == 0) {
      this.stopscrollFlag = false;
      localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
      localStorage.setItem('candidateForm', JSON.stringify(this.datas));
    } else if (this.searchContent != "" && this.searchContent != undefined) {
      this.response = [];
      // this.commonvalues.setcandidateData(this.response);
      localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
      localStorage.setItem('candidateForm', JSON.stringify(this.datas));
    } else {
      if (this.networkflag) {
        localStorage.setItem('candidateSource', JSON.stringify(this.candidateSource));
        localStorage.setItem('candidateForm', JSON.stringify(this.datas));
      }
    }
  }


  // used to sent filter data to parent new-candidate Component on every click
  updateFunction(content = "HORIZANTAL") {
    let personalNetworkData = [];
    if(this.candidateSource){
      this.candidateSource.forEach(element => {
        this.personalNetworks.forEach(x=>{
            if(x.key === element){
              personalNetworkData.push(x.networkId);
            }
        });
      });
    }

    const isBusinessNetwork = this.jobSourcesFormarray.at(0)!=undefined && this.jobSourcesFormarray.at(0).get('businessNetwork').value;

    this.candidateFilterForm.get('resetFilter').patchValue(false);

    if (this.candidateFilterData) {
      this.candidateFilterData.clickHandler.apply(this.candidateFilterData.source,
        [{
          formData: this.candidateFilterForm.getRawValue(),
          availiabilityCheckedItems: this.availablecheckbox,
          engageMentCheckedItems: this.availableForCheckboxes,
          submissionItems: this.candidate_status,
          statusCheckedItems: this.statusCheckboxes, checkedItems: this.candidateSource,
          personalNetworks : personalNetworkData,
          businessNetworks : isBusinessNetwork ? (this.businessNetworkData!= undefined ? this.businessNetworkData.map(x => x.b2bNetworkId) : []) : this.selectedBusinessNetworks,
          publishedByUsers : this.selectedPublishedBy,
          businessCustomers : this.selectedCustomers,
          customerSelectedData : this.customerPrevSelectedValue,
          publishedSelectedData : this.publishedByPrevSelectedValue,
          businessNetworkSelectedData : this.businessNetworkPrevSelectedValue,
          workMode : this.workModeCheckboxes,
          from: content,
        }]);
    }
  }



  @Output() valuesRetainedForFilters = new EventEmitter<any>(null);
  startFilter() {
    let data: any = {}
    const candidateSource = JSON.parse(localStorage.getItem('candidateSource'))
    const candidateForm = JSON.parse(localStorage.getItem('candidateForm'))
    data.candidateSource = candidateSource;
    data.candidateForm = candidateForm
    const jsonData = JSON.stringify(data);
    this.panelValue.emit('candidates')
    this.valuesRetainedForFilters.emit(jsonData);
  }

  searchfilter() {
    // if(this.searchContent.length!=0){
    this.response = [];
    this.previousSearchAfterKey1 = null;
    this.datas.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.stopscrollFlag = false;
    window.scrollTo(0, 0);
    this.applyFilternew();
  }

  apicallfilter() {
    this.util.startLoader()
    this.searchData.getcandidateCount().subscribe(res => {
      if (res != 0 && res.flag) this.stopscrollFlag = false;
      if (res != 0 && res.flag && res.status === "ACTIVE") {
        this.totalCandidatesCount += res.count;
      }
      else if (res != 0 && !res.flag || res != 0 && res.flag && res.status != "ACTIVE") {
        this.totalCandidatesCount = res.count;
      }
    });
    localStorage.setItem('candidateForm', JSON.stringify(this.datas))
  }

  onChangeCountry(event) {
    this.candidateFilterForm.get('city').patchValue(null)
    this.candidateFilterForm.get('state').patchValue(null)
    this.candidateFilterForm.get('zipCode').patchValue(null)
    this.response = [];
    // this.commonvalues.setcandidateData(this.response);
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew();
    const countryCode = event;

    if (event == "US") {
      if (this.usStatesList.length == 0) {
        // this.usStatesList = [];
        // if (this.usStatesList.length == 0) {
        this.apiService
          .query("country/getAllStates?countryCode=" + countryCode)
          .subscribe((res) => {
            res.forEach(ele => {
              this.usStatesList.push(ele.stateName)
            })
          }, err => {
            this.util.stopLoader();
          });
        // }
      }
    } else if (event == "AU") {
      const countryCode = event;
      this.stateListAU = [];

      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListAU = res;
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "IN") {
      const countryCode = event;
      this.stateListIN = [];
      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListIN = res;
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "CA") {
      const countryCode = event;
      this.stateListCA = [];

      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListCA = res;
        }, err => {
          this.util.stopLoader();
        });
    }

    this.generateWorkAutorization(countryCode);

  }

  generateWorkAutorization(countryCode: string) {
    this.apiService.query('listvalue/find?domain=WORK_AUTHORIZATION_' + countryCode).subscribe(res => {
      if (res != undefined && res.code == '00000' && res.data.listValues.length > 0) {
        this.showWorkAuthorization = true
        this.WACheckboxes = []
        this.WACheckboxes = [{ label: 'All', selected: false, disable: false }]
        this.util.stopLoader()
        this.usStatesList = []
        res.data.listValues[0].listItems.forEach((ele) => {
          this.WACheckboxes.push({ label: ele.item, selected: false, disable: false })

        })


      }
      else {
        this.showWorkAuthorization = false
      }

    });
  }

  onChangestate(state) {
    this.candidateFilterForm.value.state = state;
    this.response = [];
    this.previousSearchAfterKey1 = null;
    // this.commonvalues.setcandidateData(this.response);
    this.candidateFilterForm.get('city').patchValue(null)
    this.candidateFilterForm.get('zipCode').patchValue(null)
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew();
  }

  onChangecity(city) {

    this.response = [];
    this.previousSearchAfterKey1 = null;

    // this.commonvalues.setcandidateData(this.response);
    this.candidateFilterForm.value.city = city;
    this.candidateFilterForm.get('zipCode').patchValue(null)
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew();
  }

  onChangezipcode(zipCode) {
    this.response = [];
    this.previousSearchAfterKey1 = null;
    // this.commonvalues.setcandidateData(this.response);
    this.candidateFilterForm.value.zipCode = zipCode;
    // this.filterWhenNoneCandidateSouce()
    this.applyFilternew();
  }

  resetFilternew() {
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = []
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    this.value = 0;
    this.highValue = 0;
    this.value1 = 0;
    this.highValue1 = 0;
    this.showWorkAuthorization = false;

    if (this.candidateFilterForm != undefined) {
      this.candidateFilterForm.get('state').patchValue(null)
      this.candidateFilterForm.get('country').patchValue(null)
      this.candidateFilterForm.get('city').patchValue(null)
      this.candidateFilterForm.get('zipCode').patchValue(null)


      this.WACheckboxes.forEach(item => item.selected = false);  // cleint type -- work auth
      this.statusCheckboxes.forEach(item => item.selected = false);
      this.availableForCheckboxes.forEach(item => item.selected = false);
      this.availablecheckbox.forEach(item => item.selected = false);
      this.candidate_status.forEach(item => item.selected = false);


      for (let key of this.keyarrayCandidatesouces) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
      }

      for (let key of this.keysarrWorks) {
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
      }
      this.candidateSource = ['myCandidates'];
      if (this.owner && this.isMyCandidateShowedOnLoad) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(true);
      } else if (!this.isMyCandidateShowedOnLoad) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceCandidates').patchValue(true);
      }
      this.obj1.searchAfterKey = null;
      this.applyFilternew();
    }
  }

  openFilter() {
    this.filterOn = true
  }

  createCandidateFilterForm() {
    this.candidateFilterForm = this.formBuilder.group({
      source: this.formBuilder.array([]),
      workMode:[],
      availableIn: null,
      engagementType: null,
      status: null,
      submissionFilters: null,
      workAuthorization: null,
      searchAfterKey: null,
      country: null,
      userId: localStorage.getItem('userId'),
      state: null,
      city: null,
      zipCode: null,
      resetFilter: false,
      limit: 10,
      totalExperience: null,
      postedFrom: null,
      postedTo: null,
      experienceFrom: null,
      experienceTo: null,
      postedDayRangeContent: 'Posted (Days)',
      experienceTypeContent: 'Experience (Years)',
      workTypeContent: 'Work Mode',
      postedDayRange: 'Any (Days)',
      experienceType: 'Any (Years)',
      candidateSourceContent: 'Candidate Source',
      engagementTypeContent: 'Engagement Type',
      availabilityContent: 'Availability',
      statusContent: 'Status',
      publishedByContent: 'Published by',
      customerContent: 'Customer',
      businessNetworkContent: 'Business Networks',
    });

  }

  jobsoucefilterFrom(d) {
    this.jobSourcesFormarray.push(this.candidateService.candidateSourcefields(d));
    this.candidateFilterForm.patchValue(this.filterFormData);
    if(this.isDefaultNetwork){
       this.candidateSource.push(this.selectedNetworkId);
       this.updateFunction("VERTICAL");
    }
    else if(this.jobSourcesFormarray.at(0)!=undefined && this.selectedNetworkId){
      this.jobSourcesFormarray.at(0).get(this.selectedNetworkId).patchValue(true);
      const keyValuePairs: Record<string, any> = this.jobSourcesFormarray.getRawValue()[0];
      const keyCounts = Object.values(keyValuePairs).reduce((count, value) => {
        return count + (value ? 1 : 0);
      }, 0);
      this.sourceCount = keyCounts;
      this.candidateSource.push(this.selectedNetworkId);
      this.updateFunction("VERTICAL");
    }
  }

  get jobSourcesFormarray() {
    return this.candidateFilterForm.get('source') as UntypedFormArray;
  }

  // Single source of truth for the Candidate Source badge count. Counts the
  // `true` flags in the source group, excluding the "all" toggle and entries
  // that aren't real user picks for the current role/plan (recruiter
  // "myCandidates", Free/Pro "businessNetwork"). Called from ngOnChanges
  // (parent-driven refresh) AND from jobSoucecheck (live in-dropdown toggles)
  // so the badge stays in sync with the checkboxes instead of going stale —
  // the count used to update only on the input round-trip, which never fired
  // on a toggle.
  private computeSourceCount(source0: Record<string, boolean>): number {
    if (!source0) {
      return 0;
    }
    const userType = localStorage.getItem('userType');
    return Object.keys(source0).reduce((count, value) => {
      if (userType === GigsumoConstants.RECRUITER && value === 'myCandidates') {
        return count;
      }
      if ((this.memberShipType === 'Free' || this.memberShipType === 'Pro') && value === 'businessNetwork') {
        return count;
      }
      // 'myEmployees' has no checkbox in this dropdown (SuperAdmin org view only),
      // but the All toggle still patches it true → never count it here.
      if (value === 'all' || value === 'myEmployees') {
        return count;
      }
      return count + (source0[value] ? 1 : 0);
    }, 0);
  }




  onKeyZip(event: any) {
    let data: any = {};
    data.countryCode = "US";
    data.zipCode = event.target.value;
    data.stateCode = "";
    if (data.zipCode.length === 5) {
      this.apiService.create("country/geodetails", data).subscribe((res) => {
        if (
          res &&
          res != null &&
          res != "" &&
          res.length > 0 &&
          event.target.value != ""
        ) {
          res.forEach((ele) => {
            let cityName = ele.cityName;
            let stateName = ele.stateName;
            this.candidateFilterForm.patchValue({
              city: cityName,
              state: stateName,
            });
          });
        }
      }, err => {
        this.util.stopLoader();
      });
    } else if (data.zipCode.length < 5 || data.zipCode.length > 5) {

    }
  }

  reloadFilter(value: string) {
    if (value === 'reload') {
      this.previousSearchAfterKey1 = null;
      this.datas.searchAfterKey = null;
      this.previousSearchAfterKey = null;
      this.obj1.searchAfterKey = null;
      this.applyFilternew();
    }
  }

  // thiru work

  // job souce check uncheck

  // No teamCandidates: Job Seekers have no workspace (checkbox hidden for them).
  JobSeekerRole=[ "all","myCandidates","memberNetworksCandidates","marketPlaceCandidates"];

  async jobSoucecheck(event, lable, param?: any) {

    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    // this.response = [];
    // this.commonvalues.setcandidateData(this.response);
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;


    if (this.userType === GigsumoConstants.JOB_SEEKER) {
      const sourceFormArray = (this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup;
      const formValues = this.candidateFilterForm.get('source').value;
     if (lable === 'all') {
        this.candidateSource = [];
        this.JobSeekerRole.forEach(key => {
        sourceFormArray.get(key).patchValue(event.target.checked);
        this.candidateSource.push(key);
        });
      } else {
        sourceFormArray.get(lable).patchValue(event.target.checked);
        if (event.target.checked) {
          this.candidateSource.push(lable);
          sourceFormArray.get('all').patchValue(formValues[0].myCandidates && formValues[0].memberNetworksCandidates&& formValues[0].marketPlaceCandidates);
        } else {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
          sourceFormArray.get('all').patchValue(false);
        }
      }

      this.candidateSource = Array.from(new Set(this.candidateSource));
    }



    if (event.target.checked == true && this.userType!=GigsumoConstants.JOB_SEEKER) {

      for (let key of this.keyarrayCandidatesouces) {
        if (lable == 'all' && key != 'all') {
          if (key == 'myCandidates' && this.owner && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'teamCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'benchNetworkCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'freeLancerNetworkCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'mtaNetworkCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'jobSeekerNetworkCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'featured' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'suggestedCandidates' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          } else if (key == 'marketPlaceCandidates' && this.owner && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        } else {
          if (lable != 'all' && !this.candidateSource.includes(lable)) {
            this.candidateSource.push(lable);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
      }

      if(this.checkIfAllChecked()){
        this.jobSourcesFormarray.at(0).get('all').patchValue(true);
      }

    }
    if (event.target.checked == false && this.userType!=GigsumoConstants.JOB_SEEKER)  {

      if (lable != 'all') {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(event.target.checked);
      }

      if (lable == 'all') {
        for (let key of this.keyarrayCandidatesouces) {
          if (this.candidateSource.includes(key)) {
            this.candidateSource.splice(this.candidateSource.indexOf(key), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
      } else {
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }
    }

    let personalNetworkData = [];

    this.candidateSource.forEach(element => {
      this.personalNetworks.forEach(x=>{
          if(x.key === element){
            personalNetworkData.push(x.networkId);
          }
      });
    });

    if (lable === 'all' && this.userType!=GigsumoConstants.JOB_SEEKER) {
      let isChecked = event.target.checked;
      this.jobsouceCheckedAll(isChecked);

      if(isChecked){
        this.candidateSource = [];
        Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key=>{
          this.candidateSource.push(key);
        });
      }
      else{
        this.candidateSource = [];
      }

      this.setToDefaulFilter();
      this.setToDefaulFilter("CUSTOMER");
      this.publishedPayload.personalNetworks = isChecked ? this.allPersonalNetworks : [];
      this.publishedPayload.memberNetworkChosen = isChecked;
      this.customerPayload.businessNetworks = isChecked ? this.allBusinessNetwork : [];

      this.getBusinessCustomers();
      this.getPublishedBy();
    }


    if(lable === "memberNetworksCandidates"){
      this.setToDefaulFilter('CUSTOMER');
      let isMemberNetworkTrue = this.jobSourcesFormarray.at(0).get(lable).value;
      this.customerPayload.memberNetworkChosen =  isMemberNetworkTrue;
      this.customerPayload.businessList = this.customerPrevSelectedValue.map(x => x.businessId);
      await this.getBusinessCustomers("MEMBER_NETWORK");
    }
    else if(lable === "businessNetwork"){
        this.istempBusinessNetwork = this.jobSourcesFormarray.at(0).get(lable).value;
        this.setToDefaulFilter("CUSTOMER");
        this.customerPayload.businessNetworks = event.target.checked ? this.businessNetworkData.map(x => x.b2bNetworkId) : [];
        this.selectedBusinessNetworks = this.istempBusinessNetwork ? this.customerPayload.businessNetworks : [];
        this.businessNetworkPrevSelectedValue = [];
        this.busienssNetworkCount = 0;
        this.businessNetworkData =  this.tempBusinessNetworks.map(x => {
          x.enabled = false;
          return x;
        });
        this.customerPayload.businessList = this.customerPrevSelectedValue.map(x => x.businessId);
        this.customerPayload.businessNetworkChosen = this.istempBusinessNetwork;
        await this.getBusinessCustomers();
    }
    else if(param === "personalNetworks"){
      this.setToDefaulFilter();
      this.publishedPayload.personalNetworks = personalNetworkData;
      this.publishedPayload.users = this.publishedByPrevSelectedValue.map(x => x.userId);
      await this.getPublishedBy();
    }

    const isMyCandidatesChecked : boolean  = this.jobSourcesFormarray.at(0) != undefined ? this.jobSourcesFormarray.at(0).get('myCandidates').value : false;
    this.statusCheckboxes = updateStatusCheckBox(this.statusCheckboxes ,this.owner ? isMyCandidatesChecked : false);
    this.statusCount = this.statusCheckboxes.filter(x => !x.disable).length;

    // Refresh the badge from the live form state (the parent doesn't reassign
    // filterChanges on a horizontal toggle, so ngOnChanges won't do it for us).
    const liveSource = this.jobSourcesFormarray.at(0) as UntypedFormGroup;
    this.sourceCount = this.computeSourceCount(liveSource ? liveSource.getRawValue() : null);

    this.updateFunction();
  }


  // Only the checkboxes the template actually renders — mirrors the *ngIf's in
  // the Source dropdown. Commented-out / hidden controls (benchNetworkCandidates,
  // featured, suggestedCandidates, …) can never be ticked one by one, so they
  // mustn't block the auto-"All".
  private visibleSourceKeys(): string[] {
    const keys = ['marketPlaceCandidates', 'memberNetworksCandidates'];
    if (this.owner) keys.push('myCandidates');
    if (!this.filterApplied) {
      keys.push(...(this.personalNetworks || []).map(x => x.key));
      if (this.userType != 'student' && this.userType != GigsumoConstants.JOB_SEEKER) keys.push('teamCandidates');
    }
    if (this.userType != GigsumoConstants.JOB_SEEKER && this.businessNetworkData?.length > 0) keys.push('businessNetwork');
    return keys;
  }

  checkIfAllChecked() {
    const group = this.jobSourcesFormarray.at(0) as UntypedFormGroup;
    if (!group) return false;
    return this.visibleSourceKeys().every(key => group.get(key)?.value === true);
  }

  jobsouceCheckedAll(checked) {
    Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key=>{
      ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(checked);
    });
  }

  candiasasrce() {
    this.candidateSourceFlag = !this.candidateSourceFlag
  }

  jobclassifsd() {
    this.jobClassificationFlag = !this.jobClassificationFlag
  }
  availbwelkdfv() {
    this.availableForFlag = !this.availableForFlag
  }

  candidateFlagsd() {
    this.candidateFlag = !this.candidateFlag
  }

  wortjh() {
    this.workAuthFlag = !this.workAuthFlag
  }

  locatioesdnfjh() {
    this.locationFlag = !this.locationFlag
  }
  workefkjhgtyp() {
    this.workTypeFlag = !this.workTypeFlag
  }

  experienfa() {
    this.experienceFlag = !this.experienceFlag
  }





  // availableCheckbox check and uncheck
  availabletype(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = []
    // this.commonvalues.setcandidateData(this.response);

    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    let AllData = [];
    this.availablecheckbox.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }

      if(item.label != 'All'){
        AllData.push(item);
      }
    });

    if (event.target.checked == true) {
      this.ischeckedJobClassification = true;
      if (lable == 'All') {
        for (let key of this.availablecheckbox) {
          if (key.label != 'All' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key.label);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.available(event);
      } else {
        if (!this.candidateSource.includes(lable)) {
          this.candidateSource.push(lable);
          this.candidateSource = [...new Set(this.candidateSource)]
        }

      }
      // this.filterWhenNoneCandidateSouce();

      if(AllData.every(x => x.selected === true)){
        this.availablecheckbox[0].selected = true;
      }

    }
    if (event.target.checked == false) {
      if (lable != 'All') {
        this.availablecheckbox[0].selected = false;
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }

      if (lable == 'All') {
        for (let key of this.availablecheckbox) {
          if (this.candidateSource.includes(key.label) && key.label != 'All') {
            this.candidateSource.splice(this.candidateSource.indexOf(key.label), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.available(event);
      }
    }

    this.applyFilternew(param);
    this.updateFunction();
  }

  available(event) {
    const checked = event.target.checked;
    this.availablecheckbox.forEach(item => item.selected = checked);
  }

  // availableCheckbox check and uncheck
  availableCheckboxChange(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = []
    // this.commonvalues.setcandidateData(this.response);

    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    let allData = [];
    this.availableForCheckboxes.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
      if(item.label != 'All'){
        allData.push(item);
      }
    });

    if (event.target.checked == true) {
      this.ischeckedJobClassification = true;
      if (lable == 'All') {
        for (let key of this.availableForCheckboxes) {
          if (key.label != 'All' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key.label);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.jobclassifiCheckAll(event);
      } else {
        if (!this.candidateSource.includes(lable)) {
          this.candidateSource.push(lable);
          this.candidateSource = [...new Set(this.candidateSource)]
        }

      }

      if(allData.every(x => x.selected === true)){
        this.availableForCheckboxes[0].selected = true;
      }

    }
    else if (event.target.checked == false) {
      if (lable != 'All') {
        this.availableForCheckboxes[0].selected = false;
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }

      if (lable == 'All') {
        for (let key of this.availableForCheckboxes) {
          if (this.candidateSource.includes(key.label) && key.label != 'All') {
            this.candidateSource.splice(this.candidateSource.indexOf(key.label), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.jobclassifiCheckAll(event);
      }
    }

    this.updateFunction();
  }

  jobclassifiCheckAll(event) {
    const checked = event.target.checked;
    this.availableForCheckboxes.forEach(item => item.selected = checked);
  }

  //  client type check and uncheck
  workAuthcheckbox(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = [];
    // this.commonvalues.setcandidateData(this.response);
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;

    this.WACheckboxes.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
    });



    if (event.target.checked == true) {
      this.ischeckedClientType = true;

      if (lable == 'All') {
        for (let key of this.WACheckboxes) {
          if (key.label != 'All') {
            this.candidateSource.push(key.label);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.clientTypeCheckedAll(event);
      } else {
        this.candidateSource.push(lable);
        this.candidateSource = [...new Set(this.candidateSource)]
      }
      // this.filterWhenNoneCandidateSouce()
    }

    if (event.target.checked == false) {
      if (lable != 'All') {
        this.WACheckboxes[0].selected = false;
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }

      }

      if (lable == 'All') {
        for (let key of this.WACheckboxes) {
          if (this.candidateSource.includes(key.label) && key.label != 'All') {
            this.candidateSource.splice(this.candidateSource.indexOf(key.label), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.clientTypeCheckedAll(event);
      }

    }

    if (this.ischeckedClientType && this.ischeckedClientTypeAll) {
      event.target.checked = true
    }
    this.applyFilternew(param);
    this.updateFunction();
  }


  statusChange(checked, label) {
    if (label === 'All') {

      if (checked) {
        this.statusCheckboxes.forEach(item => item.selected = true);
      }
      else if (!checked) {
        this.statusCheckboxes.forEach(item => item.selected = false);
      }
    }
    else if (label != 'All') {

      this.statusCheckboxes.forEach(item => {
        if (item.label === label) {
          item.selected = checked;
        }
      });

      const isAllchecked = this.statusCheckboxes.filter(val => val.label != 'All').every(item => item.selected === true);
      this.statusCheckboxes[0].selected = isAllchecked;

    }
    this.updateFunction();
  }
  workModeChange(checked, label) {
    if (label === 'All') {

      if (checked) {
        this.workModeCheckboxes.forEach(item => item.selected = true);
      }
      else if (!checked) {
        this.workModeCheckboxes.forEach(item => item.selected = false);
      }
    }
    else if (label != 'All') {

      this.workModeCheckboxes.forEach(item => {
        if (item.label === label) {
          item.selected = checked;
        }
      });

      const isAllchecked = this.workModeCheckboxes.filter(val => val.label != 'All').every(item => item.selected === true);
      this.workModeCheckboxes[0].selected = isAllchecked;

    }
    this.updateFunction();
  }
  clientTypeCheckedAll(event) {
    const checked = event.target.checked;
    this.WACheckboxes.forEach(item => item.selected = checked);

  }

  candidate_CheckAll(event) {
    const checked = event.target.checked;
    this.candidate_status.forEach(item => item.selected = checked);

  }

  // status check and uncheck
  statuscheck(event, lable) {
    this.stopscrollFlag = false
    this.candidateFilterForm.value.searchAfterKey = null
    this.response = [];
    // this.commonvalues.setcandidateData(this.response);
    this.obj.searchAfterKey = null;
    this.obj1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;

    this.statusCheckboxes.forEach(item => {
      if (lable === 'Available') {
        this.activeStatus = true
      }
      else {
        this.activeStatus = false
      }
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
    });


    if (event.target.checked == true) {
      this.ischeckedStatus = true;
      if (lable == 'All') {
        for (let key of this.statusCheckboxes) {
          if (key.label != 'All' && !this.candidateSource.includes(key)) {
            this.candidateSource.push(key.label);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.statusCheckAll(event);
      } else {
        if (!this.candidateSource.includes(lable)) {
          this.candidateSource.push(lable);
          this.candidateSource = [...new Set(this.candidateSource)]
        }
      }
      if (this.activeStatus) {
        if (!this.owner) {
          if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {

            for (let key of this.keyarrayCandidatesouces) {
              if (key != "myCandidates") {
                ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
                if (key != 'all') {
                  this.candidateSource.push(key);
                  this.candidateSource = [...new Set(this.candidateSource)]
                }

              }
            }

          }
        }
        if (this.owner) {
          if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {

            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(true);
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').patchValue(true);
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').patchValue(true);
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').patchValue(true);
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').patchValue(true);
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').patchValue(true);
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(true);

            this.candidateSource.push("myCandidates");
            this.candidateSource.push("teamCandidates");
            this.candidateSource.push("benchNetworkCandidates");
            this.candidateSource.push("freeLancerNetworkCandidates");
            this.candidateSource.push("mtaNetworkCandidates");
            this.candidateSource.push("jobSeekerNetworkCandidates");
            if (!this.FeaSugg) {
              this.candidateSource.push("featured");
              this.candidateSource.push("suggestedCandidates");
            }

            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.activeStatus = null;
      }
      else if (!this.activeStatus) {
        if (this.owner) {
          if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {

            ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(true);

            this.candidateSource.push("myCandidates");

            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.activeStatus = null;

      }
    }



    if (event.target.checked == false) {
      if (lable != 'All') {
        this.statusCheckboxes[0].selected = false;
        if (this.candidateSource.includes(lable)) {
          this.candidateSource.splice(this.candidateSource.indexOf(lable), 1);
        }
      }


      if (lable == 'All') {
        for (let key of this.statusCheckboxes) {
          if (this.candidateSource.includes(key.label) && key.label != 'All') {
            this.candidateSource.splice(this.candidateSource.indexOf(key.label), 1);
            this.candidateSource = [...new Set(this.candidateSource)]
          }
        }
        this.statusCheckAll(event);
      }

    }

    this.applyFilternew()
  }

  statusCheckAll(event) {
    const checked = event.target.checked;
    this.statusCheckboxes.forEach(item => item.selected = checked);

  }

  // filterWhenNoneCandidateSouce() {
  //   if (!this.owner) {
  //     if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {


  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').patchValue(true);
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(true);

  //       this.candidateSource.push("teamCandidates");
  //       this.candidateSource.push("benchNetworkCandidates");
  //       this.candidateSource.push("freeLancerNetworkCandidates");
  //       this.candidateSource.push("mtaNetworkCandidates");
  //       this.candidateSource.push("jobSeekerNetworkCandidates");
  //       if (!this.FeaSugg) {
  //         this.candidateSource.push("featured");
  //         this.candidateSource.push("suggestedCandidates");
  //       }

  //       this.candidateSource = [...new Set(this.candidateSource)]
  //     }
  //   }

  //   if (this.owner) {
  //     if (((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('benchNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkCandidates').value == false &&
  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('jobSeekerNetworkCandidates').value == false) {

  //       ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myCandidates').patchValue(true);

  //       this.candidateSource.push("myCandidates");

  //       this.candidateSource = [...new Set(this.candidateSource)]
  //     }
  //   }
  // }

  removeEntitynew(value, index) {

    if (this.jobfilter != true) {

      this.candidateFilterForm.value.searchAfterKey = null
      this.response = []
      this.obj.searchAfterKey = null;
      this.obj1.searchAfterKey = null;
      this.previousSearchAfterKey = null;
      this.previousSearchAfterKey1 = null;

      this.stopscrollFlag = false

      this.candidateSource.splice(index, 1);
      if (this.keyarrayCandidatesouces.includes(value)) {
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(false);
        ((this.candidateFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(value).patchValue(false);
      }
      if (this.keysarrWorks.includes(value)) {
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(false);
        ((this.candidateFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(value).patchValue(false);
      }

      this.WACheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.WACheckboxes[0].selected = false
        }
      });

      this.statusCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.statusCheckboxes[0].selected = false
        }
      });

      this.availableForCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.availableForCheckboxes[0].selected = false
        }
      });

      this.availablecheckbox.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.availablecheckbox[0].selected = false
        }
      });


      this.candidate_status.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.candidate_status[0].selected = false
        }
      });

      if (value == 'myCandidates') {
        this.response = []
        this.obj.searchAfterKey = null;
        this.obj1.searchAfterKey = null;
        this.previousSearchAfterKey = null;
        this.previousSearchAfterKey1 = null;
      }
      // this.applyFilternew();
    }
  }

  chatbottom() {
    let seletedItem: any = {};
    // this._socket.ngOnDestroy();
    // this._socket.connections();
    seletedItem.owner = true;
    this.messagemodelflag = true;
    seletedItem.userId = localStorage.getItem('userId');
    this.messageData = [];
    seletedItem.groupType = "CANDIDATE";
    seletedItem.messageType = "CANDIDATE";
    seletedItem.id = null;
    // Bottom chat: also load direct USER-to-USER contacts (message/new/contact/{userId})
    // and merge them into the list, same as the Home page bottom chat.
    seletedItem.bottomChat = true;
    this.messageData = seletedItem;
  }

  closeMessage(event) {
    this.messagemodelflag = false;
    // this._socket.ngOnDestroy();

  }

  onFilterToggle(value: any) {
    const receivedData = JSON.parse(value);
    // this.data1 = receivedData.jobForm;
    // this.jobSource = receivedData.jobSource;
    // this.filterapicall()
  }

  openFilterSlider() {
    if (!this.isFilterOpen) {
      this.isFilterOpen = true;
      this.jobService.setSliderToggle(true, 'candidate-listing', null,false);
    }
  }

  closeFilterSlider() {
    if (this.isFilterOpen) {
      this.isFilterOpen = false;
      this.jobService.setSliderToggle(false, 'candidate-listing', null,false);
    }
  }
  @Output() panelValue = new EventEmitter<any>(null);

  onMenuItemClick(event, param?: any): void {
    event.stopPropagation();

    if (param != null) {
      // this.meunTrigger.closeMenu();
    }
  }


  selectedPublishedBy = [];
  selectedCustomers = [];
  selectedBusinessNetworks = [];
  customerPrevSelectedValue = [];
  publishedByPrevSelectedValue = [];
  businessNetworkPrevSelectedValue = [];
  async onSelectChange(data : any[] , content, object?){

    if(data && this.isSelectedField(content)){

      const key =
      content === "selectedCustomers" ?  "businessId" :
      content === "selectedBusinessNetworks" ? "b2bNetworkId" :
      "userId";

      this[content] = data.filter(x => x.enabled === true).map(c => c[key]);

      if(content === "selectedCustomers"){
        this.customerPrevSelectedValue = data.filter(x => x.enabled === true);
        this.customerPayload.businessList = this.selectedCustomers;
        const datas = this.customersList.getValue().sort((x, y) => (x.enabled === y.enabled)? 0 : x.enabled ? -1 : 1);
        this.customersList.next(datas);
      }
      else if(content === "selectedPublishedBy"){
        this.publishedByPrevSelectedValue = data.filter(x => x.enabled === true);
        this.publishedPayload.users = this.selectedPublishedBy;
        const datas = this.publishedByList.getValue().sort((x, y) => (x.enabled === y.enabled)? 0 : x.enabled ? -1 : 1);
        this.publishedByList.next(datas);
      }
      else if(content === "selectedBusinessNetworks"){
        this.selectedBusinessNetworks = this.selectedBusinessNetworks.length === 0 ?
        this.allBusinessNetwork : this.selectedBusinessNetworks;
        this.businessNetworkPrevSelectedValue = data;
        this.customerPayload.businessNetworks = this.selectedBusinessNetworks;
        this.customerPayload.businessList =  object.selectedCustomers;
        this.setToDefaulFilter("CUSTOMER");
        await this.getBusinessCustomers();
      }

      this.updateFunction();
    }
  }

  isSelectedField(c : keyof CandidateFilterTemplateComponent) : boolean{
    return c === "selectedPublishedBy" || c === "selectedCustomers" || c === "selectedBusinessNetworks";
  }

  onPublishSearch(e){
    this.publishedPayload.searchContent = e;
    this.setToDefaulFilter();
    this.getPublishedBy();
  }

  onPublishScroll(e){
    this.publishedPayload = {
      ...this.publishedPayload,
      searchAfterKey : this.publishedByPrevSearchAfterKey
    }
    this.getPublishedBy();
  }


  onCustomerSearch(e){
    this.customerPayload.searchContent = e;
    this.setToDefaulFilter("CUSTOMER");
    this.getBusinessCustomers();
  }

  onCustomerScroll(e){
    this.customerPayload = {
      ...this.customerPayload,
      searchAfterKey : this.customersPrevSearchAfterKey
    }
    this.getBusinessCustomers();
  }

}
